import React from 'react';
import { fromUtcToDeviceTimeZoneForMessages } from '../../utils/dateFormatter';
import { isObjectNotEmpty } from '../../utils/objectUtils';
import { toName } from '../../utils/stringFormatter';
import { Col, Row } from 'react-bootstrap';
import { Avatar } from '../../components/Avatar';
import { getProgramNameById } from '../../utils/entityUtils';
import { FaArrowCircleRight, FaStethoscope } from 'react-icons/fa';
import ROUTES from '../../constants/routes';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

const NewMessageToast = ({ chatMessage, encounter, changeActiveEncounter, getProviderDetails }) => {
    //#region useSearchParams

    const [searchParams, setSearchParams] = useSearchParams();

    //#endregion
    //#region useNavigate

    const navigate = useNavigate();

    //#endregion
    //#region useLocation

    const location = useLocation();

    //#endregion
    //#region goTos

    const goTo = (path) => {
        navigate({ pathname: path, search: searchParams.toString() }, { state: { from: location }, replace: true });
    };

    //#endregion

    let chatMessageContent = chatMessage?.mediaRefId ? '[Image]' : (chatMessage?.message ?? '');
    let chatMessageDateTime = fromUtcToDeviceTimeZoneForMessages(chatMessage?.sentAt);
    // console.log('latest message', chatMessageContent);

    const onNewMessageClick = async () => {
        // console.log('test click');
        // console.log('encounterId', encounter?.id);
        await changeActiveEncounter(encounter?.id);
        goTo(ROUTES.MY_MESSAGES);
    };

    let otherUser = getProviderDetails(encounter?.providerId ?? null);

    return (
        <a onClick={() => { onNewMessageClick(); }}>
            <div className="d-flex flex-row">
                <div className="flex-shrink-0 me-2">
                    {isObjectNotEmpty(otherUser) ? (
                        <Avatar
                            size="md"
                            className="rounded-circle text-white"
                            type={otherUser?.imageRefId ? 'image' : 'icon'}
                            imageRefId={otherUser?.imageRefId ?? null}
                            status={'busy'}
                            alt={toName(otherUser)}
                            name={toName(otherUser)}
                            variant="ready-orange"
                            icon={FaStethoscope}
                        />
                    ) : (
                        <Avatar
                            size="md"
                            className="rounded-circle text-white"
                            type={'icon'}
                            status={'busy'}
                            alt={encounter?.messageName ?? 'Chat Thread'}
                            name={encounter?.messageName ?? 'Chat Thread'}
                            variant="ready-orange"
                            icon={FaStethoscope}
                        />
                    )}
                </div>
                <div className="d-inline-flex flex-column me-2">
                    <h5 className="fw-bold mb-0">{toName(otherUser) ?? encounter?.messageName ?? 'Chat Thread'}</h5>
                    <div className="fs-5 mb-0" dangerouslySetInnerHTML={{ __html: chatMessageContent }} />
                    <div className="fs-6 mb-0 text-muted">
                        <span>
                            {chatMessageDateTime}
                        </span>
                    </div>
                </div>
                <div className="text-end ms-auto flex-shrink-0">
                    <FaArrowCircleRight size={24} fill="var(--geeks-ready-black)" />
                </div>
            </div>
        </a>
    );
};

export default NewMessageToast;